import Vue from "vue";

export default {
  namespaced: true,
  state: {
    checkingLogin: true,
    userLogged: false,
    user: null
  },
  getters: {},
  mutations: {
    logout: state => {
      state.checkingLogin = true;
      state.userLogged = false;
      state.user = null;
    },
    startLoginCheck: (state) => {
      state.checkingLogin = true;
    },
    endLoginCheck: (state) => {
      state.checkingLogin = false;
    },
    updateUserInfo: (state, user) => {
      state.userLogged = true;
      state.user = user;
    }
  },
  actions: {
    logout: ({commit}) => {
      return new Promise(resolve => {
        commit('logout');
        resolve();
      });
    },
    startLoginCheck: ({commit}) => {
      return new Promise(resolve => {
        commit("startLoginCheck");
        resolve();
      });
    },
    endLoginCheck: ({commit}) => {
      return new Promise(resolve => {
        commit("endLoginCheck");
        resolve();
      });
    },
    updateUserInfo: ({ commit, dispatch, state }, obj) => {
      return new Promise(resolve => {
        commit("updateUserInfo", obj.data);
        dispatch(
          "updateLang",
          { lang: state.user.language, app: obj.app },
          { root: true }
        ).then(() => {
          resolve();
        });
      });
    }
  }
};
